/* Two parts of what you get: the partnership and Justine. */
export const PartsSection = () => (
  <section id="w-parts" className="w-sec w-snap" aria-labelledby="w-parts-title">
    <div className="x-wrap">
      <div className="w-head">
        <p className="x-eyebrow x-eyebrow--ink">The model</p>
        <h2 id="w-parts-title" className="x-h2">
          Two parts of what you get
        </h2>
      </div>
      <div className="w-parts-grid">
        <article className="w-part w-part--deal">
          <p className="w-part-n">01 · Ownership</p>
          <h3>The partnership</h3>
          <p className="w-part-body">
            United buys a majority stake in your firm. You retain ownership and continue to lead it, with our engineers, capital
            and deal team behind you. Shared ownership makes this a long-term commitment: we invest in building the business
            together and share in the value we create.
          </p>
        </article>
        <article className="w-part w-part--os">
          <p className="w-part-n">02 · Product</p>
          <h3>Justine</h3>
          <p className="w-part-body">
            Practice management with AI agents that take on accounting production, one workflow at a time, starting with
            bookkeeping. Your accountants keep the client relationships, the judgment and the final say.
          </p>
        </article>
      </div>
    </div>
  </section>
)
